import React from 'react';
import PropTypes from 'prop-types';
import { Row, Column } from 'mage-components';
import { Frame, IconStar, SpacerVertical, Typography } from '@klarna/bubble-ui';
import ExpandableFrame from './ExpandableFrame';
const componentPropTypes = {
    countryPlatforms: PropTypes.array.isRequired,
    selectedCountry: PropTypes.string.isRequired,
};
export const Platforms = ({ countryPlatforms, selectedCountry }) => {
    const subComponentPropTypes = {
        platformType: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
    };
    const PlatformsOfType = ({ platformType, title }) => (React.createElement(ExpandableFrame, { title: title },
        React.createElement(Row, null, countryPlatforms
            .filter(p => p.type === platformType)
            .map(p => {
            var _a;
            return (React.createElement(Column, { columns: { mobile: 3 }, key: p.key },
                React.createElement(SpacerVertical, { spaceToken: "space.100" }),
                React.createElement(Typography, { textToken: "text-style/text/paragraphs/body/bold" },
                    p.label,
                    ((_a = p === null || p === void 0 ? void 0 : p.standardOptionIn) === null || _a === void 0 ? void 0 : _a.includes(selectedCountry)) ? React.createElement(IconStar, null) : ''),
                React.createElement(Typography, { textToken: "text-style/text/paragraphs/default/regular" }, p.partner_override_id)));
        }))));
    PlatformsOfType.propTypes = subComponentPropTypes;
    return (React.createElement(Frame, null,
        React.createElement(Row, null,
            React.createElement(Column, { columns: { mobile: 8 } },
                React.createElement(Typography, { textToken: "text-style/headings/titles/bold/tertiary" }, "Platforms"))),
        React.createElement(PlatformsOfType, { platformType: "SUPPORTED", title: "Supported" }),
        React.createElement(PlatformsOfType, { platformType: "NATIVE", title: "Native Partner" }),
        React.createElement(PlatformsOfType, { platformType: "MANUAL_CONTACT", title: "Manual contact (sales)" }),
        React.createElement(PlatformsOfType, { platformType: "WITHOUT_LANDING_PAGE", title: "Not supported (Without landing page)" })));
};
Platforms.propTypes = componentPropTypes;
